<div class="legal">
  <h1>Terms of Service</h1>
  <p class="effective">Effective: October 9, 2026</p>

  <section>
    <h2>1. Acceptance</h2>
    <p>
      By accessing or using Beat Duel ("the Service"), you agree to these Terms. If you do not agree, do not use the
      Service.
    </p>
  </section>

  <section>
    <h2>2. Eligibility</h2>
    <p>
      You must be at least 13 years old to create an account. Users under 18 need parental or guardian consent. By
      registering, you represent that you meet these requirements.
    </p>
  </section>

  <section>
    <h2>3. Accounts</h2>
    <p>
      You are responsible for maintaining the confidentiality of your login credentials and for all activity under your
      account. You agree to provide accurate information when registering and to keep it up to date. We may suspend or
      terminate accounts that violate these Terms.
    </p>
  </section>

  <section>
    <h2>4. User Content</h2>
    <p>
      You retain ownership of any content you submit (tracks, profile information, votes). By submitting content, you
      grant Beat Duel a non-exclusive, worldwide, royalty-free license to display, distribute, and promote your content
      within the Service.
    </p>
    <p>
      You represent that you have the right to submit any content you provide and that it does not infringe any
      third-party rights. You must not submit content that is unlawful, defamatory, obscene, or otherwise objectionable.
    </p>
  </section>

  <section>
    <h2>5. Prohibited Conduct</h2>
    <ul>
      <li>Creating multiple accounts to manipulate votes or rankings</li>
      <li>Using bots, scripts, or automated tools to access or play the Service on your behalf</li>
      <li>Harassing, threatening, or impersonating other users</li>
      <li>Attempting to access other users' accounts or private data</li>
      <li>Circumventing rate limits or security measures</li>
      <li>Submitting copyrighted content without authorization</li>
    </ul>
  </section>

  <section>
    <h2>6. Third-Party Services</h2>
    <p>
      Beat Duel integrates with YouTube, SoundCloud, TikTok, and Spotify. Your use of those platforms is governed by
      their respective terms of service. Beat Duel is not responsible for third-party content or service availability.
    </p>
    <p>
      Beat Duel uses YouTube API Services to play music. By using Beat Duel, you agree to be bound by the
      <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer">YouTube Terms of Service</a>.
    </p>
  </section>

  <section>
    <h2>7. Points and Rankings</h2>
    <p>
      Points, rankings, achievements, and Song Market currency and holdings are for entertainment purposes within the
      Service. They have no monetary value, cannot be purchased with real money, and cannot be exchanged, transferred,
      or redeemed outside the platform.
    </p>
    <p>
      Beat Duel may operate AI-controlled players to keep games and duels active. They follow the same rules as everyone
      else, and their results count toward rankings in the same way.
    </p>
  </section>

  <section>
    <h2>8. Subscriptions</h2>
    <p>
      Premium features may require a paid subscription. Subscription terms, pricing, and cancellation policies will be
      presented at the time of purchase. We reserve the right to change pricing with reasonable notice.
    </p>
  </section>

  <section>
    <h2>9. Content Removal</h2>
    <p>
      We may remove content or disable accounts that violate these Terms or applicable law. Users may report content
      they believe violates these Terms using the in-app reporting feature.
    </p>
  </section>

  <section>
    <h2>10. Disclaimers</h2>
    <p>
      The Service is provided "as is" without warranties of any kind, express or implied. We do not guarantee
      uninterrupted or error-free operation. AI-generated scores are algorithmic estimates and do not represent
      professional evaluation.
    </p>
  </section>

  <section>
    <h2>11. Limitation of Liability</h2>
    <p>
      To the maximum extent permitted by law, Beat Duel shall not be liable for any indirect, incidental, special, or
      consequential damages arising from your use of the Service.
    </p>
  </section>

  <section>
    <h2>12. Changes to Terms</h2>
    <p>
      We may update these Terms at any time. Continued use of the Service after changes constitutes acceptance. Material
      changes will be communicated via the Service or email.
    </p>
  </section>

  <section>
    <h2>13. Contact</h2>
    <p>Questions about these Terms? Email <a href="mailto:hello@beatduel.com">hello@beatduel.com</a>.</p>
  </section>
</div>

<style>
  .legal {
    max-width: 720px;
    margin: 0 auto;
    padding: 2rem 1rem;
    color: var(--text-secondary);
    line-height: 1.7;
  }
  h1 {
    font-size: 1.5rem;
    color: var(--text);
    margin-bottom: 0.25rem;
  }
  .effective {
    font-size: 0.85rem;
    color: var(--text-muted);
    margin-bottom: 2rem;
  }
  h2 {
    font-size: 1rem;
    color: var(--text);
    margin: 1.5rem 0 0.5rem;
    font-weight: 600;
  }
  p {
    margin: 0.5rem 0;
  }
  ul {
    margin: 0.5rem 0;
    padding-left: 1.5rem;
  }
  li {
    margin: 0.35rem 0;
  }
  a {
    color: var(--cyan);
  }
  section {
    margin-bottom: 0.5rem;
  }
</style>
